<template>
    <div v-loading="loading">
        <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit"
            style="margin: 20px; width: 60%; min-width: 600px">
            <el-form-item label="Enabled">
                <el-checkbox v-model="form.enabled"></el-checkbox>
            </el-form-item>
            <el-form-item label="Setpoint (°F)">
                <el-input v-model="form.setPoint" @focus="setPointFocus"></el-input>
            </el-form-item>
            <el-form-item label="Feedback Sensitivity">
                <template #label>
                    <label>Feedback Sensitivity (%E<sup>-1</sup> / °F)</label>
                </template>
                <el-input v-model="form.feedbackSensitivity"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 10px">
                <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
  
<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
    data() {
        return {
            loading: false,
            form: {
                enabled: false,
                setPoint: "",
                feedbackSensitivity: ""
            },
            user: this.$session.get("User")
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        verifySettings() {
            if (isNaN(parseInt(this.form.feedbackSensitivity)) || parseInt(this.form.feedbackSensitivity) < 0 || parseInt(this.form.feedbackSensitivity) > 100) {
                const h = this.$createElement
                this.$notify({
                    title: "Feedback Sensitivity",
                    message: "Value not valid.  Value should be between 0 and 100",
                    type: "error"
                })
                return false
            }
            return true
        },
        saveDataToPanel() {
            if (!this.verifySettings()) return
            this.loading = true
            Axios.all([
                SettingsService.changeSetting(this.user.activeZone, "Settings.ApartmentAverage.Enabled", this.form.enabled ? "true" : "false"),
                SettingsService.changeSetting(this.user.activeZone, "Settings.ApartmentAverage.Sensitivity", this.form.feedbackSensitivity),
                SettingsService.changeSetting(this.user.activeZone, "Settings.ApartmentAverage.SetPoint", this.form.setPoint)
            ])
                .then(
                    Axios.spread((enabledResponse, feedbackSensitivityResponse, setPointResponse) => {
                        //The system should update in 10 seconds.
                        this.loading = false
                        if (enabledResponse.data.result != "success" || feedbackSensitivityResponse.data.result != "success" || setPointResponse.data.result != "success") {
                            const h = this.$createElement
                            this.$notify({
                                title: "Apartment Average",
                                message: "Error trying to save data to panel",
                                type: "error"
                            })
                        } else {
                            this.$notify({
                                title: "Apartment Average",
                                message: "Settings Saved to Panel",
                                type: "info"
                            })
                        }
                    })
                )
                .catch(() => {
                    this.loading = false
                    const h = this.$createElement
                    this.$notify({
                        title: "Heat Balancer",
                        message: "Error trying to save data to panel",
                        type: "error"
                    })
                })
        },
        getData() {
            //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
            Axios.all([IOService.getSettings(this.user.activeZone)]).then(
                Axios.spread((settingsResponse) => {
                    this.form.enabled = settingsResponse.data.apartmentAverage.enabled == "true"
                    this.form.setPoint = settingsResponse.data.apartmentAverage.setpoint
                    this.form.feedbackSensitivity = settingsResponse.data.apartmentAverage.sensitivity
                })
            )
        }
    }
}
</script>
  
<style scoped>
.chart-container {
    width: 100%;
    float: left;
}

/*.chart div {
          height: 400px;
          float: left;
      }*/

.el-col {
    padding: 30px 20px;
}
</style>
  


// WEBPACK FOOTER //
// ApartmentAverage.vue?2c209609